<template>
  <div class="final">
    <top-nav :show-user="true" />
    <loading-progress
      v-if="isProcessing"
      data-active-index="9999"
      data-position="fixed"
    />
    <div class="page-content">
      <div class="row">
        <div class="col s12 l10 no-float center-aligned">
          <div class="section-title">
            SLDB <em>Act to Adapt</em> School Competition Entry
          </div>
          <div class="details justify-text">
            <p>
              Congratulations on completing your Climate Change Home Risk
              Assessment! You are one step closer to making your home more
              resilient to a Category 5 hurricane and other natural hazards.
            </p>
            <p>
              Now, do you want a chance to win up to XCD $10,000 to implement
              your proposed adaptation measures at home?
            </p>
            <p>
              Then, enter the SLDB <em>Act to Adapt</em> School Competition!
            </p>
            <b>How to Enter </b>
            <ol class="browser-default">
              <li>
                Review your Climate Change Home Risk Assessment to make sure it
                is fully completed and all information is accurate.
              </li>
              <li>
                Review your
                <router-link :to="{ name: 'adaptationPlan' }"
                  >Adaptation Plan</router-link
                >
                to ensure proposed projects reflect the key vulnerabilities at
                your home and hazards of highest priority as well as any
                measures you desire to reduce your carbon footprint and energy
                bill.
              </li>
              <li>
                Complete the <em>Act to Adapt</em> Competition Entry Form below
                before the competition deadline.
              </li>
            </ol>
            <!-- 						The competition details, rules and judging criteria are available in
						the Resource Center. -->
            <button
              style="width:80%; margin-left: 10%; margin-top: 18px;"
              class="btn-medium btn-rounded waves-effect indigo accent-2"
              @click="$_viewForm()"
            >
              <span v-if="form.submitted">Review</span>
              Competition Entry Form
            </button>
          </div>
        </div>
      </div>
      <div class="modal modal-fixed-footer submission" ref="modal">
        <div class="modal-header">
          <em>Act to Adapt</em> School Competition Entry
        </div>
        <div class="modal-content row">
          <form class="">
            <div class="col s12 rc">
              <div class="question">Full Name</div>
              <input 
              :disabled="userRole === 'subscriber'"
              v-model="form.full_name" type="text" name="fullname" />
            </div>
            <div class="col s12 rc">
              <div class="question">Gender</div>
              <p class="col s6 no-padding">
                <label>
                  <input
                   :disabled="userRole === 'subscriber'"
                    class="with-gap"
                    value="male"
                    v-model="form.gender"
                    name="gender"
                    type="radio"
                  />
                  <span>Male</span>
                </label>
              </p>
              <p class="col s6 no-padding">
                <label>
                  <input
                   :disabled="userRole === 'subscriber'"
                    class="with-gap"
                    value="female"
                    v-model="form.gender"
                    name="gender"
                    type="radio"
                  />
                  <span>Female</span>
                </label>
              </p>
            </div>
            <div class="col s12 rc">
              <div class="label-field">Name of school</div>
              <select
               :disabled="userRole === 'subscriber'"
                v-model="form.name_of_school"
                name="secondaySchool"
                id="secondaySchool"
                class="browser-default"
              >
                <option value="0" selected> Select seconday school</option>
                <option
                  :value="s.text"
                  v-for="(s, i) in schools"
                  :key="i"
                  v-html="s.text"
                ></option>
                <option value="other">Other</option>
              </select>
              <br />
              <input
                v-if="form.name_of_school === 'other'"
                type="text"
                placeholder="Please enter other"
              />
            </div>
            <div class="col s12 rc">
              <div class="label-field">School Form</div>
              <select

               :disabled="userRole === 'subscriber'"
                name="schoolForm"
                v-model="form.school_form"
                id="schoolForm"
                class="browser-default"
              >
                <option value="0" selected> Select school form</option>
                <option value="1"> Form 1</option>
                <option value="2"> Form 2</option>
                <option value="3"> Form 3</option>
                <option value="4"> Form 4</option>
                <option value="5"> Form 5</option>
              </select>
            </div>
            <div class="col s12 rc">
              <div class="label-field">Resource teacher (if applicable):</div>
              <div class="desciption">
                Enter the name of the teacher who has served as your primary
                resource person for the competition.
              </div>
              <input
               :disabled="userRole === 'subscriber'"
                v-model="form.resource_teacher"
                type="text"
                name="fullname"
              />
            </div>
            <div class="col s12 rc">
              <label>
                <input
                  type="checkbox"
                  :disabled="form.submitted"
                  v-model="form.verifySubmission"
                />
                <span>
                  I certify that my assessment is true to the best of my
                  knowledge and that the homeowner has provided their consent to
                  the assessment of their home and entry in the
                  <em>Act to Adapt</em> Competition.
                </span>
              </label>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            class=" modal-close close-modal btn-flat left grey-text text-darken-4 waves-effect"
          >
            Close
          </button>
          <button
            :disabled="!form.verifySubmission"
            @click="$_saveData(true)"
            class="btn waves-effect indigo accent-2 btn-rounded"
          >
            <span v-if="form.submitted">UPDATE</span>
            <span v-else>SUBMIT</span>
            YOUR ENTRY
          </button>
        </div>
      </div>
    </div>
    <app-bottom-tab />
  </div>
</template>

<script>
import schools from "@/JsonSchemas/schoolList";

import topNav from "@/components/topNav";
import { updateUserProfile, sendEmail, createUserPDF } from "@/api/user.api";
import { mapState } from "vuex";
import AppBottomTab from "@/components/AppBottomTab";
export default {
  name: "competition",
  components: {
    topNav,
    AppBottomTab,
  },
  data() {
    return {
      isProcessing: false,
      shouldSavePdf: false,
      modal: {
        instance: null,
        options: {
          onCloseStart: () => {
            this.$_saveToApi();
          },
          onOpenEnd: () => {
            this.form.full_name = this.fullNameX;
            this.form.name_of_school = this.user.school ? this.user.school : "";

            setTimeout(() => {
              this.formX ? Object.assign(this.form, { ...this.formX }) : "";
            }, 100);
          },
          onCloseEnd: () => {
            this.modal.instance.destroy();
            setTimeout(() => {
              this.modal.instance = null;
            }, 100);
          },
        },
      },
      schools: schools,
      form: {
        full_name: "",
        gender: "",
        name_of_school: "",
        school_form: "",
        resource_teacher: "",
        verifySubmission: false,
        submitted: false,
      },
    };
  },
  mounted() {},
  methods: {
    $_saveData(t) {
      if (this.isProcessing) return;

      this.isProcessing = true;
      if (t) this.form.submitted = true;
      this.$store.commit(
        "User/UPDATE_COMPETITION_ENTRY",
        JSON.stringify(this.form)
      );

      this.shouldSavePdf = true;

      setTimeout(() => {
        this.isProcessing = false;
        this.modal.instance.close();
      }, 1000);
      if (t) {
         this.$_sendEmail();
         this.$_confirmationDialog();
      }
    },

    $_viewForm() {
      this.modal.instance = window.M.Modal.init(
        this.$refs.modal,
        this.modal.options
      );
      setTimeout(() => {
        this.modal.instance.open();
      }, 300);
    },
    $_saveToApi(v) {
      const payload = {
        fields: {
          competition_entry: JSON.stringify(this.formX),
        },
      };
      updateUserProfile(this.user.profile, payload)
        .then((res) => {
          // Send confirmation email ?
          //toastMessage('Profile updated successfully')
        })
        .catch((err) => {
          // this.isProcessing = false;
        });

      if (this.shouldSavePdf) {
        this.createPDF();
      }
    },
    createPDF() {
      const { profile_slug, id, profile } = this.user;
      if (!profile_slug || !id) return;
      const payload = {
        slug: profile_slug,
        school: "other",
        form: this.form.school_form,
        profile,
        id,
      };

      const school = this.schools.find(
        ({ text }) => text === this.form.name_of_school
      );

      if (school) payload.school = school.value;

      try {
        createUserPDF(payload);
      } catch (error) {
        console.log(error);
      }
    },

    $_sendEmail() {
      const { email } = this.user;

      if (email) {
        const payload = {
          email,
          message:
            "Thank you for entering the SLDB Act to Adapt School Competition. Your entry has been successfully recorded. Please note that you can update your entry at any time before the Competition deadline by returning to the SLDB Act to Adapt App and making changes to the section desired, including your Adaptation Plan.",
        };

        sendEmail(payload, 3943).then((res) => {
          console.log(res.data);
        });
      }
    },
    $_confirmationDialog() {
      let data = {
        title: `Entry Confirmation`,
        message: `Thank you for entering the SLDB Act to Adapt School Competition. Your entry has been successfully recorded and a confirmation email will be sent to you. Please note that you can update your entry at any time before the Competition deadline by returning to the App and making changes to the section desired, including your Adaptation Plan.`,
        buttons: [
          {
            id: 0,
            value: "Ok",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },
        ],
        dataType: "",
      };

      this.$store.commit("TRIGGER_DIALOG", { data: data });
    },
  },
  computed: {
    ...mapState({ user: (state) => state.User.user }),
     userRole: {
      get () {
      return this.user && this.user.roles.length > 0
      ? this.user.roles[0]
      : false 
      }
     },
    fullNameX: {
      get() {
        return this.$store.state.User.user.name;
      },
    },
    formX: {
      get() {
        let object =
          this.$store.state.User.user &&
          this.$store.state.User.user.competition_entry
            ? JSON.parse(this.$store.state.User.user.competition_entry)
            : {};
        return object;
      },
    },
    homeProfileX: {
      get() {
        return JSON.parse(this.$store.state.User.user.home_profile)
          .address_community;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.final {
  padding-bottom: 64px;
  .modal {
    border-radius: 12px;
  }
  .page-content {
    padding: 24px 16px;
    max-width: 690px;
    margin: auto;
    .section-title {
      font-size: 24px;
    }
    ol {
    }
  }
  form {
    display: flow-root;
    p.col {
      margin: 0px;
    }
  }
  .question,
  .label-field {
    font-weight: 600;
    font-size: 18px;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .rc {
    margin: 0 0 18px 0px;
  }
  .desciption {
    font-size: 14px;
    padding: 12px;
    background: #efefef;
    border-radius: 3px;
    margin-bottom: 12px;
  }
}
.modal {
  max-height: 95%; //calc(100% - 128px) ;
  top: 5% !important;
  height: 93% !important;
  max-width: 768px;
  width: 99%;
  .modal-header {
    left: 0;
    right: 0;
    background: white;
    top: 0;
    height: 56px;
    line-height: 56px;
    padding: 0 24px;
    font-size: 19px;
    border-bottom: 1px solid #efefef;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .modal-content {
    height: calc(100% - 112px) !important;
  }
}
</style>
